const AmazonCognitoIdentity = require("amazon-cognito-identity-js");

const devUserPool = new AmazonCognitoIdentity.CognitoUserPool({
  UserPoolId: "ap-northeast-1_5RNqhF92T",
  ClientId: "6khae11j66v0bvb7f84heua3sq",
});

const stgUserPool = new AmazonCognitoIdentity.CognitoUserPool({
  UserPoolId: "ap-northeast-1_uyyCN1chY",
  ClientId: "4b1kmvu9m77om5c92a27io1jvg",
});

const prodUserPool = new AmazonCognitoIdentity.CognitoUserPool({
  UserPoolId: "ap-northeast-1_FwV7u6YFp",
  ClientId: "578dee3mq80l8p1hl67rdcmuj3",
});

const hotfixUserPool = new AmazonCognitoIdentity.CognitoUserPool({
  UserPoolId: "ap-northeast-1_bWeahsryP",
  ClientId: "15nce0cqdsgqngs7ge7i1euoej",
});

const advdevUserPool = new AmazonCognitoIdentity.CognitoUserPool({
  UserPoolId : "ap-northeast-1_gy7x5GHAv",
  ClientId : "19ujfkfpq7lfoomd8buho0o05"
});

const samUserPool = new AmazonCognitoIdentity.CognitoUserPool({
    UserPoolId : "ap-northeast-1_9Samuhu6Q",
    ClientId : "45regj89l96c40v0kcoi39epq0"
});

export function getUserPool() {
  if (process.env.REACT_APP_BUILD_ENV === "prod") {
    return prodUserPool;
  } else if (process.env.REACT_APP_BUILD_ENV === "stg") {
    return stgUserPool;
  } else if (process.env.REACT_APP_BUILD_ENV === "hotfix") {
    return hotfixUserPool;
  } else if (process.env.REACT_APP_BUILD_ENV === "advdev") {
    return advdevUserPool;
  } else if (process.env.REACT_APP_BUILD_ENV === "sam") {
    return samUserPool;
  }
  return devUserPool;
}

const cognitoAuth = {
  signIn: (ceId, password) => {
    return new Promise(function (resolve, reject) {
      // 何か1つでも未入力の項目がある場合、メッセージを表示して処理を中断
      if (!ceId | !password) {
        reject({ message: "Empty user name or password" });
        return;
      }

      // 認証データの作成
      let authenticationData = {
        Username: ceId,
        Password: password,
      };
      let authenticationDetails =
        new AmazonCognitoIdentity.AuthenticationDetails(authenticationData);

      let userData = {
        Username: ceId,
        Pool: getUserPool(),
      };
      let cognitoUser = new AmazonCognitoIdentity.CognitoUser(userData);

      // 認証処理
      cognitoUser.authenticateUser(authenticationDetails, {
        onSuccess: function () {
          resolve();
        },

        onFailure: function (err) {
          // サインイン失敗の場合、エラーメッセージを画面に表示
          reject(err);
        },

        // cognitoはコンソールからユーザ登録した場合必ずFORCE_CHANGE_PASSWORD 状態となるため、
        // 初回と同じパスワードでパスワード変更したことにする
        newPasswordRequired: function () {
          localStorage.setItem("isCeInitialLogin", true);
          cognitoUser.completeNewPasswordChallenge(password, {}, this);
        },
      });
    });
  },

  signOut: () => {
    const cognitoUser = getUserPool().getCurrentUser();
    if (cognitoUser) {
      cognitoUser.signOut();
    }

    let lang = localStorage.getItem("lang");
    let screen = localStorage.getItem("screen");
    localStorage.clear();
    // 言語設定と画面設定は消すと不便なので残す
    if (!!lang) {
      localStorage.setItem("lang", lang);
    }
    if (!!screen) {
      localStorage.setItem("screen", screen);
    }
  },

  changePassword: (oldPassword, newPassword, confirmPassword) => {
    return new Promise(function (resolve, reject) {
      if (newPassword !== confirmPassword) {
        reject({ errCode: 10001 });
        return;
      }

      let poolData = {
        UserPoolId: getUserPool().getUserPoolId(),
        ClientId: getUserPool().getClientId(),
      };
      let userPool = new AmazonCognitoIdentity.CognitoUserPool(poolData);
      let cognitoUser = userPool.getCurrentUser();

      if (!cognitoUser) {
        reject({ errCode: 10000 });
        return;
      }

      cognitoUser.getSession(function (err, session) {
        if (session.isValid()) {
          // パスワード変更処理
          cognitoUser.changePassword(oldPassword, newPassword, function (err) {
            if (err) {
              if (
                err.code === "InvalidParameterException" ||
                err.code === "InvalidPasswordException"
              ) {
                reject({ errCode: 10002 });
              } else if (err.code === "LimitExceededException") {
                reject({ errCode: 10003 });
              } else if (err.code === "NotAuthorizedException") {
                reject({ errCode: 10004 });
              } else {
                reject({ errCode: 10000 });
              }
            } else {
              resolve();
            }
          });
        }
      });
    });
  },

  getUserName: () => {
    const cognitoUser = getUserPool().getCurrentUser();
    return cognitoUser !== null ? cognitoUser.getUsername() : "";
  },

  getAuthorizationToken() {
    return new Promise((resolve, reject) => {
      const cognitoUser = getUserPool().getCurrentUser();
      if (cognitoUser != null) {
        cognitoUser.getSession(function (err, session) {
          if (err || !session.getIdToken()) {
            reject();
          } else {
            resolve(session.getIdToken().jwtToken);
          }
        });
      } else {
        reject();
      }
    });
  },

  sessionTimeOut(props) {
    // エラーメッセージ表示
    props.openSnackbar(props.intl.formatMessage({ id: "errCode_10005" }));
    // ログイン画面に遷移させる
    props.history.push({ pathname: "/" });
  },
};

export default cognitoAuth;
